import React, { Component } from "react";
import {Container, Col, Row} from "react-bootstrap";

export class Slider extends Component {
    render() {
        return (
            <main>
                <header className="slider showcase-full">
                    <div className="swiper-container parallax-slider">
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <div className="bg-img valign" data-background={process.env.REACT_APP_BASE_URL + "/images/home_slider/slide_1.jpg"}
                                     data-overlay-dark="3">
                                    <Container>
                                        <Row>
                                            <Col lg={11} className="offset-lg-1">
                                                <div className="caption">
                                                    <h6 className="sub-title mb-30" data-swiper-parallax="-1000">
                                                    </h6>
                                                    <h1>
                                                        <a href={"/pages/about-us"}>
                                                            <span data-swiper-parallax="-2000">معرفی شرکت</span>
                                                        </a>
                                                    </h1>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="bg-img valign" data-background={process.env.REACT_APP_BASE_URL + "/images/home_slider/slide_2.jpg"}
                                     data-overlay-dark="3">
                                    <Container>
                                        <Row>
                                            <Col lg={11} className="offset-lg-1">
                                                <div className="caption">
                                                    <h6 className="sub-title mb-30" data-swiper-parallax="-1000">
                                                    </h6>
                                                    <h1>
                                                        <a href={"/auctions/active"}>
                                                            <span data-swiper-parallax="-2000">مزایده‌ و فروش املاک</span>
                                                        </a>
                                                    </h1>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="bg-img valign" data-background={process.env.REACT_APP_BASE_URL + "/images/home_slider/slide_3.jpg"}
                                     data-overlay-dark="3">
                                    <Container>
                                        <Row>
                                            <Col lg={11} className="offset-lg-1">
                                                <div className="caption">
                                                    <h6 className="sub-title mb-30" data-swiper-parallax="-1000">
                                                    </h6>
                                                    <h1>
                                                        <a href={'/projects/under-construction'}>
                                                            <span data-swiper-parallax="-2000">پروژه‌های ساختمانی</span>
                                                        </a>
                                                    </h1>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="bg-img valign" data-background={process.env.REACT_APP_BASE_URL + "/images/home_slider/slide_4.jpg"}
                                     data-overlay-dark="3">
                                    <Container>
                                        <Row>
                                            <Col lg={11} className="offset-lg-1">
                                                <div className="caption">
                                                    <h6 className="sub-title mb-30" data-swiper-parallax="-1000">
                                                    </h6>
                                                    <h1>
                                                        <a href={'/renovations/under-construction'}>
                                                            <span data-swiper-parallax="-2000">بازسازی و بهسازی</span>
                                                        </a>
                                                    </h1>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            </div>
                        </div>

                        {/*slider setting*/}
                        <div className="slider-control">
                            <div className="swiper-button-prev swiper-nav-ctrl cursor-pointer">
                                <div><i className="fas fa-chevron-right"> </i></div>
                                <div>
                                    <span>قبل</span>
                                </div>
                            </div>
                            <div className="swiper-button-next swiper-nav-ctrl cursor-pointer">
                                <div>
                                    <span>بعد</span>
                                </div>
                                <div><i className="fas fa-chevron-left"> </i></div>
                            </div>
                        </div>
                        <div className="swiper-pagination dots"> </div>
                    </div>
                </header>
            </main>
        );
    }
}
